import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { CmsService } from 'src/_service/CmsService';
import { environment } from '../../_environments/environment';
import { GlobalService } from 'src/_service/GlobalService';
import { TranslateModule } from '@ngx-translate/core';
import { CmsButtonComponent } from '../cms-button/cms-button.component';

import { CmsFeedbackwidgetComponent } from "../cms-feedbackwidget/cms-feedbackwidget.component";
import { WINDOW } from 'src/_service/WindowService';
@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    imports: [
    CmsButtonComponent,
    TranslateModule,
    CmsFeedbackwidgetComponent
]
})
export class FooterComponent implements OnInit {

  // lang = this._translate.currentLang;
  env = { ...environment };
  currentYear = new Date().getFullYear();
  footer_slug = '/general/footer';
  content: any;
  socials = [
    { title: 'Facebook', url: 'https://www.facebook.com/EKOMENU/', src: '/assets/images/homepage/fb.svg' },
    { title: 'Instagram', url: 'https://www.instagram.com/ekomenu/', src: '/assets/images/homepage/ig.svg' },
    { title: 'Pinterest', url: 'https://nl.pinterest.com/ekomenu1', src: '/assets/images/homepage/pi.svg' }
  ];

  constructor(
    private _cmsService: CmsService,
  ) {
  }

  ngOnInit(): void {
    this._cmsService.getStory(this.footer_slug).then(data => {
      this.content = data.story.content;
    }).catch(error => {
      console.error(error)
    })
  }


}
